// extracted by mini-css-extract-plugin
module.exports = {"signaturePad":"SignaturePad_signaturePad_1y8hI"};